// projectReducer.js

import { USER_ROLE_FAILURE, USER_ROLE_REQUEST, USER_ROLE_SUCCESS } from "../Actions/Actions";

const initialState = {
  isLoading: false,
  userRoles: [],
  error: null,
};

const userRolesListReducer = (state = initialState,{type,payload}) => {
  switch (type) {
    case USER_ROLE_REQUEST:
      return { ...state, isLoading: true, error: null  };
    case USER_ROLE_SUCCESS:
      return { ...state, isLoading: false, userRoles: payload};
    case USER_ROLE_FAILURE:
      return { ...state, isLoading: false, error: payload };
    default:
      return state;
  }
};

export default userRolesListReducer;
